import { store } from "@store";
import axios from "axios";

export const showSuccessAlert =
  (message, header = "Success", onConfirm = async () => {}) =>
  async (dispatch) => {
    dispatch({
      type: "SUCCESS_ALERT",
      payload: { message, onConfirm, visible: true, header },
    });
  };

export const CMSRequestInterceptor = (config) => {
  const logIn = JSON.parse(sessionStorage.getItem("login"));

  config = { ...config, baseURL: sessionStorage.getItem("base_url") };

  if (!logIn) {
    return config;
  }

  if (logIn.sessionkey) {
    config = {
      ...config,
      ...{ headers: { common: { SessionKey: `${logIn.sessionkey}` } } },
    };
  }

  return config;
};

export const CMSResponseErrorInterceptor = (error) => {
  const logIn = JSON.parse(sessionStorage.getItem("login"));

  if (logIn) {
    if (error.response) {
      if ([401].includes(error.response.status)) {
        sessionStorage.removeItem("login");
        window.location = "/?expired=1";
      } else {
        if (error.response.data) {
          const message =
            typeof error.response.data === "string"
              ? error.response.data
              : "There was an error completing your request";
          store.dispatch(showSuccessAlert(message, "Error"));
        } else {
          store.dispatch(
            showSuccessAlert(
              "There was an error completing your request!",
              "Error",
            ),
          );
        }
      }
    } else {
      store.dispatch(
        showSuccessAlert(
          "There was an error completing your request!",
          "Error",
        ),
      );
    }
  }

  return Promise.reject(error);
};

export const CMSResponseSuccessInterceptor = (response) => response;

const cmsInstance = axios.create();

cmsInstance.interceptors.request.use(CMSRequestInterceptor);
cmsInstance.interceptors.response.use(
  CMSResponseSuccessInterceptor,
  CMSResponseErrorInterceptor,
);

export default cmsInstance;
